import React from 'react'
import ServicesLanding from './servicesLanding'
import ServicesBottom from './servicesBottom'
import NavBar from '../../../../components/navbar/navbar'
import Footer from '../../../../components/footer/footer'
export default function Services() {


    return (
        <>
            <NavBar />
            <ServicesLanding />
            <ServicesBottom />
            <Footer />
        </>
    )
}
